import React, { useEffect, useState } from "react";
import { Breadcrumbs, Button, Modal } from "../../../../components/core";
import BranchProfileForm from "../components/branch-form";
import { useDispatch, useSelector } from "react-redux";
import { Strings } from "../../../../constants/strings";
import {
  useApolloClient,
  useLazyQuery,
  useMutation,
  useQuery,
} from "@apollo/client";
import { useNavigate, useParams } from "react-router-dom";
import {
  GET_HEAD_OFFICE_BY_PARTNER_ID,
  SEARCH_BRANCHES,
  UPDATE_BRANCHES,
} from "../../../../constants/graphql/branch-queries";
import { SEARCH_PARTNERS_FOR_TABLE } from "../../../../constants/graphql/partners-query";
const breadcrumbItems = [
  {
    label: "Branches",
    path: `/branches/`,
  },
  { label: "Branch Profile", path: "#" },
];

const EditSelectedBranch = () => {
  const operatorId = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user")).operator_id
    : null;

  //   utils
  const dispatch = useDispatch();
  const client = useApolloClient();
  const navigate = useNavigate();
  const { partnerBranchId } = useParams();

  //   local variables
  const [branchProfile, setBranchProfile] = useState({
    operatorId: operatorId,
    branchLevel: false,
    partnerCategoryNo: "-1",
    partnerId: "",
    partnerBranch: "",
    address: "",
    contactPerson: "",
    contactPerson2: "",
    contactPosition: "",
    contactPosition2: "",
    zipCode: "",
    landline: "",
    landline2: "",
    mobile: "",
    mobile2: "",
    email: "",
    email2: "",
    remarks: "",
  });
  const [partnerCategoryItems, setPartnerCategoryItems] = useState([]);
  const [changesMade, setChangesMade] = useState(false);
  const contactPersonFields = [
    {
      index: 1,
      suffix: "",
      fields: {
        contactPerson: "contactPerson",
        contactPosition: "contactPosition",
        mobile: "mobile",
        email: "email",
        landline: "landline",
      },
    },
    {
      index: 2,
      suffix: "2",
      fields: {
        contactPerson: "contactPerson2",
        contactPosition: "contactPosition2",
        mobile: "mobile2",
        email: "email2",
        landline: "landline2",
      },
    },
  ];
  const [validation, setValidation] = useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "Invalid data",
    message: "",
    open: false,
  });
  const [partnerList, setPartnerList] = useState([]);
  const [headOfficeExists, setHeadOfficeExists] = useState(false);

  // gql
  const searchBranches = useQuery(SEARCH_BRANCHES, {
    variables: {
      operatorId: operatorId,
      partnerBranchId: partnerBranchId,
    },
  });
  const partners = useQuery(SEARCH_PARTNERS_FOR_TABLE, {
    variables: {
      operatorId: operatorId,
      ...(branchProfile.partnerCategoryNo !== "-1" && {
        partnerCategoryId: branchProfile.partnerCategoryNo,
      }),
    },
  });
  const [updateBranches] = useMutation(UPDATE_BRANCHES);
  const [findHeadOffice, { data: headOfficeData }] = useLazyQuery(
    GET_HEAD_OFFICE_BY_PARTNER_ID
  );

  const handleOnChange = (event) => {
    const { name, value, checked } = event.target;
    console.log({ name, value, checked });

    // Validation for numeric fields
    if (
      name === "tinNumber" ||
      name === "zipCode" ||
      name === "mobile" ||
      name === "mobile2" ||
      name === "landline" ||
      name === "landline2"
    ) {
      const tinRegex = /^\d*$/;
      if (!tinRegex.test(value)) {
        setChangesMade(false);
        return;
      }
    }

    // Handle branchLevel toggle
    if (name === "branchLevel") {
      // For checkbox: checked = true means make it head office (branchLevel = 0)
      // checked = false means make it sub branch (branchLevel = 1)
      const newBranchLevel = checked ? 0 : 1;

      // // If trying to make this a head office (checked = true) but head office exists
      // if (headOfficeExists) {
      //   setValidation({
      //     icon: `${process.env.PUBLIC_URL}/assets/images/warning.png`,
      //     title: "Head Office Already Exists",
      //     message: `A head office already exists for this partner (${headOfficeData?.getHeadOfficeByPartnerId[0]?.partnerBranch}). Please remove the existing head office first.`,
      //     open: true,
      //     actions: (
      //       <div className="grid grid-cols-1 gap-2">
      //         <Button
      //           value={"OK"}
      //           className={"p-2"}
      //           onClick={() => {
      //             setValidation(false);
      //             // Don't update branchLevel, keep current state
      //           }}
      //         />
      //       </div>
      //     ),
      //   });
      //   return;
      // }

      // If trying to remove as head office (unchecking)
      if (
        branchProfile.branchLevel === 0 &&
        headOfficeData?.getHeadOfficeByPartnerId[0]?.partnerBranchId ===
          partnerBranchId
      ) {
        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/warning.png`,
          title: "Remove as Head Office?",
          message: `You are removing ${branchProfile.partnerBranch} as a head office. This office will be assigned as a sub branch.`,
          open: true,
          actions: (
            <div className="grid grid-cols-2 gap-2">
              <Button
                value={"Cancel"}
                className={"p-2"}
                onClick={() => {
                  setValidation(false);
                  // Don't update branchLevel, keep current state
                }}
              />
              <Button
                value={"OK"}
                className={"p-2"}
                onClick={() => {
                  setValidation(false);
                  setBranchProfile({
                    ...branchProfile,
                    branchLevel: newBranchLevel,
                  });
                  setChangesMade(true);
                }}
              />
            </div>
          ),
        });
        return;
      }

      // Direct update for other cases
      setBranchProfile({
        ...branchProfile,
        branchLevel: newBranchLevel,
      });
      setChangesMade(true);
      return;
    }

    // Handle partnerCategoryNo changes
    if (name === "partnerCategoryNo") {
      partners.refetch({
        operatorId: localStorage.getItem("user")
          ? JSON.parse(localStorage.getItem("user")).operator_id
          : "",
        partnerCategoryId: value,
      });
      setHeadOfficeExists(false);
      setBranchProfile({
        ...branchProfile,
        partnerId: "",
        branchLevel: "", // Reset branchLevel
        partnerCategoryNo: value,
      });
      setChangesMade(true);
      return;
    }

    // Handle partnerId changes
    if (name === "partnerId") {
      setBranchProfile({
        ...branchProfile,
        partnerId: value,
        branchLevel: "", // Reset branchLevel
      });
      setChangesMade(true);
      return;
    }

    // General field update
    setBranchProfile({
      ...branchProfile,
      [name]: value,
    });
    setChangesMade(true);
  };

  const showValidationError = (message) => {
    setValidation({
      icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
      title: Strings.popup_error_title,
      message,
      open: true,
      actions: (
        <div className="grid grid-cols-1 gap-2">
          <Button
            value={"OK"}
            className={"p-2"}
            onClick={() => setValidation(false)}
          />
        </div>
      ),
    });
  };

  console.log({ branchProfile });

  const handleSaveChanges = () => {
    let updatedData = {
      ...branchProfile,
      operatorId: operatorId,
      mobile: "63" + branchProfile.mobile,
      mobile2: "63" + branchProfile.mobile2,
      branchLevel: parseInt(branchProfile.branchLevel),
    };
    delete updatedData.partnerId;
    console.log({ updatedData });

    updateBranches({ variables: { branches: [updatedData] } })
      .then((data) => {
        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
          title: Strings.popup_success_title_default,
          message: Strings.popup_success_message_edit,
          open: true,
          actions: (
            <div className="grid grid-cols-1 gap-2">
              <Button
                value={"OK"}
                className={"p-2"}
                onClick={() => {
                  setValidation(false);
                  window.location.reload();
                }}
              />
            </div>
          ),
        });
      })
      .catch((e) => {
        if (e.message.includes("duplicate")) {
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
            title: Strings.popup_error_title,
            message: Strings.popup_error_message_duplicate,
            open: true,
            actions: (
              <div className="grid grid-cols-1 gap-2">
                <Button
                  value={"OK"}
                  className={"p-2"}
                  onClick={() => setValidation(false)}
                />
              </div>
            ),
          });
        } else {
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
            title: Strings.popup_error_title,
            message: Strings.popup_error_message_edit,
            open: true,
            actions: (
              <div className="grid grid-cols-1 gap-2">
                <Button
                  value={"OK"}
                  className={"p-2"}
                  onClick={() => setValidation(false)}
                />
              </div>
            ),
          });
        }
      });
  };

  const handleCancelChanges = () => {
    // dispatch(onClearDataReducer());
    // console.log(partnerProfileData.address);
    // setOpenCancelModal(false);
    navigate(`/branches`);
  };

  useEffect(() => {
    if (branchProfile.partnerId !== "") {
      findHeadOffice({
        variables: {
          partnerId: branchProfile.partnerId,
        },
      });
    }
  }, [branchProfile.partnerId]);

  useEffect(() => {
    if (searchBranches.data) {
      let branchProfileData = searchBranches.data.searchBranches[0];
      let tempVar = {
        branchLevel: branchProfileData.branchLevel,
        partnerId: branchProfileData.partner.partnerId,
        partnerBranchId: branchProfileData.partnerBranchId,
        partnerBranch: branchProfileData.partnerBranch,
        address: branchProfileData.address,
        contactPerson: branchProfileData.contactPerson,
        contactPerson2: branchProfileData.contactPerson2,
        contactPosition: branchProfileData.contactPosition,
        contactPosition2: branchProfileData.contactPosition2,
        landline: branchProfileData.landline.replace("*", ""),
        landline2: branchProfileData.landline2.replace("*", ""),
        mobile: branchProfileData.mobile.substring(2),
        mobile2: branchProfileData.mobile2.substring(2),
        email: branchProfileData.email,
        email2: branchProfileData.email2,
        zipCode: branchProfileData.zipCode,
        remarks: branchProfileData.remarks,
        branchStatus: branchProfileData.branchStatus,
        statusComments: branchProfileData.statusComments,
        loadBalance: branchProfileData.loadBalance,
      };
      console.log({ tempVar });
      setBranchProfile(tempVar);
    }
  }, [searchBranches.data]);

  useEffect(() => {
    if (partners.data) {
      let tempVar = [];
      partners.data.searchCouriers.forEach((element) => {
        tempVar.push({
          value: element.partnerId,
          name: element.companyNickname,
        });
      });
      setPartnerList(tempVar);
    }
  }, [partners.data]);

  useEffect(() => {
    if (
      headOfficeData &&
      headOfficeData.getHeadOfficeByPartnerId !== undefined
    ) {
      let headOfficeIdentifier =
        headOfficeData.getHeadOfficeByPartnerId.length > 0;

      setHeadOfficeExists(headOfficeIdentifier);

      console.log({ headOfficeIdentifier });
    }
  }, [headOfficeData?.getHeadOfficeByPartnerId]);

  return (
    <>
      <Breadcrumbs items={breadcrumbItems} />

      {/* <ContentContainer containerTitle={`Add Branch`}> */}
      <BranchProfileForm
        isEditing={false}
        branchProfileData={branchProfile}
        partnerCategoryItems={partnerCategoryItems}
        contactPersonFields={contactPersonFields}
        partnerTypesItems={partnerList}
        changesMade={changesMade}
        headOfficeExists={headOfficeExists}
        headOfficeName={
          headOfficeExists
            ? headOfficeData?.getHeadOfficeByPartnerId[0]?.partnerBranch
            : ""
        }
        amIHeadOffice={
          headOfficeData?.getHeadOfficeByPartnerId[0]?.partnerBranchId ===
          partnerBranchId
        }
        handleOnChange={handleOnChange}
        handleSaveChanges={handleSaveChanges}
        handleCancelChanges={handleCancelChanges}
        setValidation={setValidation}
      />

      <Modal
        icon={validation.icon}
        title={validation.title}
        message={validation.message}
        open={validation.open}
        actions={validation.actions}
      />
      {/* </ContentContainer> */}
    </>
  );
};

export default EditSelectedBranch;
